import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2da8f1f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tooltip" }


export default /*#__PURE__*/_defineComponent({
  __name: 'BulmaTooltip',
  props: {
  label: {
    type: String,
    default: ''
  },
  position: {
    validator(value: string) {
      return (new Set(['is-top', 'is-right', 'is-bottom', 'is-left'])).has(value)
    },
    default: 'is-top'
  },
  type: {
    validator(value: string) {
      return (new Set([
        'is-primary', 'is-danger',
        'is-warning', 'is-info'
      ])).has(value)
    },
    default: 'is-primary'
  },
  wrapText: Boolean,
  disabled: Boolean,
  fixedWidth: {
    type: String
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("span", {
      style: _normalizeStyle({ width: __props.fixedWidth? __props.fixedWidth : null }),
      class: _normalizeClass(['tooltiptext',
                  __props.position,
                  __props.type,
                  __props.wrapText ? 'fixed-width' : 'no-wrap-ws'])
    }, _toDisplayString(__props.label), 7), [
      [_vShow, !__props.disabled]
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})